import React from 'react';
import { W9Form } from '@/components/shared/W9Form';

const VendorW9Page: React.FC = () => {
  return (
    <div className="container mx-auto py-8">
      <W9Form />
    </div>
  );
};

export default VendorW9Page;